import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import CustomerHeader from "@/components/CustomerHeader";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentReturn({ cancel = false }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(cancel ? "cancel" : "checking");
  const [attempts, setAttempts] = useState(0);
  const { refreshUser } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (cancel) return;
    if (!sessionId) { setStatus("error"); return; }
    let alive = true;
    let n = 0;
    const poll = async () => {
      if (!alive) return;
      n += 1;
      setAttempts(n);
      if (n > 12) { setStatus("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refreshUser();
          return;
        }
        if (data.payment_status === "expired") { setStatus("expired"); return; }
      } catch {
        // continue polling
      }
      setTimeout(poll, 2500);
    };
    poll();
    return () => { alive = false; };
  }, [sessionId, cancel, refreshUser]);

  return (
    <div className="cosmic-bg min-h-screen">
      <div className="stars" />
      <CustomerHeader />
      <main className="max-w-lg mx-auto px-4 sm:px-6 py-16 text-center">
        {status === "checking" && (
          <div data-testid="payment-checking">
            <Loader2 className="w-16 h-16 mx-auto gold-text animate-spin" />
            <h1 className="font-serif-myst text-3xl mt-6">Ödemen kontrol ediliyor</h1>
            <p className="text-white/60 mt-2">Deneme {attempts}/12</p>
          </div>
        )}
        {status === "paid" && (
          <div data-testid="payment-paid">
            <CheckCircle2 className="w-20 h-20 mx-auto text-emerald-400" />
            <h1 className="font-serif-myst text-4xl mt-6">Ödemen başarılı!</h1>
            <p className="text-white/70 mt-2">Jetonların/premium üyeliğin hesabına yüklendi.</p>
            <button onClick={() => nav("/panel")} className="btn-gold mt-8 px-8 py-3 rounded-full">Panele Git</button>
          </div>
        )}
        {(status === "cancel" || status === "expired" || status === "error" || status === "timeout") && (
          <div data-testid={`payment-${status}`}>
            <XCircle className="w-20 h-20 mx-auto text-red-400" />
            <h1 className="font-serif-myst text-4xl mt-6">Ödeme tamamlanmadı</h1>
            <p className="text-white/70 mt-2">Bir sorun oldu veya ödemeyi iptal ettin.</p>
            <Link to="/magaza" className="btn-gold mt-8 px-8 py-3 rounded-full inline-block">Mağazaya Dön</Link>
          </div>
        )}
      </main>
    </div>
  );
}
